import { Box, Typography, Button, Paper, Chip } from '@mui/material';
import { useUser } from '../../context/userContext';
import { clearAuthStorage } from '../../utils/authStorage';

const PP = "'Poppins', sans-serif";

export default function BlockedScreen() {
  const { user } = useUser();

  const logout = () => {
    clearAuthStorage();
    window.location.href = '/';
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper sx={{ maxWidth: 520, width: '100%', p: { xs: 3, md: 5 }, borderRadius: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img src="/nexwaveLogo.png" alt="Nexwave" style={{ height: 48, marginBottom: 8 }} />
          <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: '#0F172A', fontFamily: PP }}>
            Hi {user?.firstName || user?.username}!
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: '#64748B', fontFamily: PP }}>
            Account Status
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Chip label="Account Inactive" sx={{ backgroundColor: '#FEE2E2', color: '#991B1B', fontWeight: 600, fontSize: '0.85rem', px: 1.5, py: 2, fontFamily: PP }} />
        </Box>

        <Typography sx={{ fontSize: '0.9rem', color: '#374151', fontFamily: PP, mb: 3, textAlign: 'center' }}>
          Your account is inactive because there have been no sales in the last 2 months.
          Please contact your admin to reactivate your access.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            onClick={logout}
            sx={{ fontFamily: PP, textTransform: 'none', color: '#64748B' }}
          >
            Log out
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
